import { TYPES } from "./types";

const initialState = {
    transactions: [],
    loading: false,
    lazyLoading: false,
    error: null,
};

const paymentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case TYPES.FETCHING_TRANSACTIONS_START:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case TYPES.FETCHING_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                transactions: action.payload,
                loading: false,
                error: null,
            };
        case TYPES.FETCHING_TRANSACTIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default paymentsReducer;
